// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"2b26996f","377":"ba85327c","453":"8ecf5fb9"}[chunkId] + ".chunk.js";
};